module.exports = "https://static.zego.com/_next/static/images/scooter-eb7d4a78e8b8333689cf76e9c288b80b.svg";